import getGlobals from './globals';
import regexps from '../constants/regular-expressions';

const getGlobalBySource = (rootState, globalSource) => {
  const globals = getGlobals(rootState);
  const match = globalSource.match(regexps.WS_GLOBAL_ID_FROM_SOURCE);
  const globalId = match && match[1];
  if (!globalId) return null;

  return globals.find((global) => global.id === globalId) || null;
};

export default getGlobalBySource;
